import { authState } from '../../lib/auth.js';
import { BaseComponent } from '../../lib/base-component.js';
import { css, html } from '../../vendor/lit.min.js';

class LandingPage extends BaseComponent {
    static styles = css`
        :host { display: block; }
        .top-bar {
            position: absolute; top: 0; right: 0; padding: 1rem 1.5rem; z-index: 10;
        }
        .hero {
            position: relative;
            text-align: center;
            padding: 4rem 1rem 3rem;
            background: #336699;
            color: white;
        }
        .hero h1 { font-size: 2.5rem; font-weight: 700; margin-bottom: 0.75rem; }
        .hero .tagline {
            font-size: 1.15rem; color: #b8c6db; max-width: 600px;
            margin: 0 auto 2rem; line-height: 1.6;
        }
        .section { max-width: 900px; margin: 0 auto; padding: 2rem 1.5rem; }
        .section h2 { font-size: 1.75rem; font-weight: 600; margin-bottom: 1rem; }
        .section p { font-size: 1rem; color: #555; line-height: 1.7; }
        .help-section {
            text-align: center; padding: 3rem 1.5rem; max-width: 600px; margin: 0 auto;
        }
        .help-section h2 { font-size: 1.75rem; font-weight: 600; margin-bottom: 0.75rem; }
        .help-section p { color: #555; margin-bottom: 1.5rem; line-height: 1.6; }
        .footer {
            text-align: center; padding: 1.5rem; color: #aaa; font-size: 0.8rem;
            border-top: 1px solid #eee;
        }
        .footer a { color: #aaa; text-decoration: none; }
        .footer a:hover { color: #666; }
    `;

    _handleLogin() {
        this.dispatchEvent(new CustomEvent('login', { bubbles: true, composed: true }));
    }

    render() {
        return html`
            <div class="hero">
                <div class="top-bar">
                    <button class="btn btn-outline-light btn-sm" @click="${this._handleLogin}">Sign In</button>
                </div>
                <h1>Dice Driven Design</h1>
                <p class="tagline">
                    The identity and access management platform for Dice Driven's digital tabletop games and tools.
                </p>
            </div>

            <div class="section">
                <h2>Who We Are</h2>
                <p>
                    Dice Driven Design is a small studio focused on building digital tools
                    for tabletop RPG players. We're passionate about the hobby and want to
                    make it more accessible, more automated, and more fun.
                </p>
            </div>

            <div class="section">
                <h2>What We Build</h2>
                <p>
                    Dice Driven Design is building RPGish, a cross-platform tabletop RPG that brings
                    automated, GM-less gameplay to Steam, mobile, and web. D3 Auth provides identity
                    and access management across all of our games and tools.
                </p>
            </div>

            <div class="section">
                <h2>Trust &amp; Security</h2>
                <p>
                    We never store passwords — sign in with your Microsoft account or a one-time
                    email code. All connections use TLS, tokens are signed with RS256 and short-lived,
                    and we only collect what's needed to run your account.
                </p>
            </div>

            <div class="help-section">
                <h2>Need Help?</h2>
                <p>
                    If you're having trouble signing in or have questions about your account,
                    reach out at <a href="mailto:support@dicedriven.com">support@dicedriven.com</a>.
                </p>
            </div>

            <div class="footer">
                <a href="/terms" target="_blank">Terms of Service</a> &middot; <a href="/privacy" target="_blank">Privacy Policy</a>
                <br>
                &copy; ${new Date().getFullYear()} Dice Driven Design LLC${authState._config?.version ? html` &middot; ${authState._config.version}` : ''}
            </div>
        `;
    }
}

customElements.define('landing-page', LandingPage);
